export default __webpack_public_path__ + "static/media/khinka.9d9edfcc.PNG";